import { ALLOCATIONS, EXPERIMENTS } from '@fiverr-private/listing_experiments';

export const shouldShowFiltersModal = (isBusiness: boolean, isTouch: boolean, abTests: Record<string, number>) =>
    !isBusiness && !isTouch && Number(abTests[EXPERIMENTS.CROWS_FILTERS_MODAL]) > Number(ALLOCATIONS.CONTROL);
